import { on, createReducer, createFeature } from '@ngrx/store';
import {
    EntityState,
    EntityAdapter,
    createEntityAdapter,
} from '@ngrx/entity';

import { common } from '@qwyk/models';

import { CustomTagsActions } from './custom-tags.actions';

export const CUSTOM_TAGS_FEATURE_KEY = 'customTags';

export interface CustomTagsState extends EntityState<common.CustomTag> {
    loading: boolean;
    error: any | string | null; // last known error (if any)
    suggestions: common.SearchCustomTag[];
}

export const customTagsAdapter: EntityAdapter<common.CustomTag> =
    createEntityAdapter<common.CustomTag>();

export const initialState: CustomTagsState =
    customTagsAdapter.getInitialState({
        loading: false,
        error: null,
        suggestions: []
    });

const reducer = createReducer(
    initialState,
    on(
        CustomTagsActions.tagEntity,
        CustomTagsActions.updateTag,
        CustomTagsActions.loadTags,
        CustomTagsActions.searchTags,
        CustomTagsActions.linkTagToEntity,
        CustomTagsActions.unlinkTagFromEntity, state => ({
            ...state,
            error: null,
            loading: true,
        })
    ),
    on(CustomTagsActions.tagEntitySuccess, (state, { data }) => {
        const tagToAdd = data && data.length > 0 ? data[0] : undefined;

        if (tagToAdd) {
            return customTagsAdapter.addOne(tagToAdd, {
                ...state,
                loading: false,
                error: null,
            });
        } else {
            return {
                ...state,
            };
        }
    }),
    on(
        CustomTagsActions.updateTagSuccess,
        CustomTagsActions.linkTagToEntitySuccess,
        CustomTagsActions.unlinkTagFromEntitySuccess, (state) => ({
            ...state,
            error: null,
            loading: false
        })
    ),
    on(CustomTagsActions.searchTagsSuccess, (state, { custom_tags }) => ({
        ...state,
        error: null,
        loading: false,
        suggestions: custom_tags
    })),
    on(CustomTagsActions.loadTagsSuccess, (state, { custom_tags, isSuggestion }) => {
        if (isSuggestion) {
            return {
                ...state,
                error: null,
                loading: false,
                suggestions: custom_tags.map(tag => ({ id: tag.id, name: tag.attributes.name })) as common.SearchCustomTag[]
            }
        }
        return customTagsAdapter.setAll(custom_tags, {
            ...state,
            loading: false
        });
    }),
    on(
        CustomTagsActions.backendFailure,
        CustomTagsActions.loadTagsFailure,
        CustomTagsActions.updateTagFailure,
        CustomTagsActions.searchTagsFailure,
        CustomTagsActions.tagEntityFailure,
        CustomTagsActions.linkTagToEntityFailure,
        CustomTagsActions.unlinkTagFromEntityFailure,
        (state, { error }) => ({
            ...state,
            error,
            loading: false,
        })
    ),
    on(CustomTagsActions.reset, () => initialState)
);

export const customTagsFeature = createFeature({
    name: CUSTOM_TAGS_FEATURE_KEY,
    reducer,
});
